import type { ApiBody, ApiQuery } from '../../../shared/api/contracts'
import { apiRequest, apiGet, apiPost, apiPut, apiDelete } from './transport'

export function fetchCategoriesOverview(params: ApiQuery<'GET /admin/categories/overview'>, signal?: AbortSignal) {
  return apiRequest<'GET /admin/categories/overview'>(`/admin/categories/overview?${new URLSearchParams(params)}`, { signal })
}

export function fetchCategoryDetails(params: ApiQuery<'GET /admin/categories/details'>, signal?: AbortSignal) {
  return apiRequest<'GET /admin/categories/details'>(`/admin/categories/details?${new URLSearchParams(params)}`, { signal })
}

export async function fetchCategoriesSummary(params: ApiQuery<'GET /admin/categories/summary'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  if (params.dateFrom) u.set('dateFrom', params.dateFrom)
  if (params.dateTo) u.set('dateTo', params.dateTo)
  return apiGet<'GET /admin/categories/summary'>(`/admin/categories/summary?${u.toString()}`, signal)
}

export async function fetchCategories(signal?: AbortSignal) {
  return apiGet<'GET /admin/categories'>('/admin/categories', signal)
}

export async function createCategory(payload: ApiBody<'POST /admin/categories'>, signal?: AbortSignal) {
  return apiPost<'POST /admin/categories'>('/admin/categories', payload, signal)
}

export async function updateCategory(id: string, payload: ApiBody<'PUT /admin/categories/:id'>, signal?: AbortSignal) {
  return apiPut<'PUT /admin/categories/:id'>(`/admin/categories/${encodeURIComponent(id)}`, payload, signal)
}

export async function archiveCategory(id: string, signal?: AbortSignal) {
  return apiDelete<'DELETE /admin/categories/:id'>(`/admin/categories/${encodeURIComponent(id)}`, signal)
}
